import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  viewChild,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastContainerDirective, ToastrService } from 'ngx-toastr';
import { CdkOverlayContainerDirective } from '@shared/directives/cdk-overlay-container.directive';
import { GlobalLoadingComponent } from '@shared/components/global-loading/global-loading.component';
import { NgClass } from '@angular/common';
import { IS_EMBED_LINK } from '@shared/constants/is-embed-link.constant';
import { NetworkStatusComponent } from '@shared/components/network-status/network-status.component';
import { AppStore } from './app.store';

@Component({
  selector: 'app-root',
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    RouterOutlet,
    CdkOverlayContainerDirective,
    GlobalLoadingComponent,
    NgClass,
    ToastContainerDirective,
    NetworkStatusComponent,
  ],
})
export class App {
  private toastrService = inject(ToastrService);
  readonly deviceType = inject(AppStore).deviceType;
  readonly toast = viewChild(ToastContainerDirective);
  protected readonly IS_EMBED_LINK = IS_EMBED_LINK;

  constructor() {
    effect(() => {
      const toast = this.toast();
      if (!toast) {
        return;
      }
      this.toastrService.overlayContainer = toast;
    });
  }
}
